export default {
  api: {
    companyContact: {
      companyId: {
        notNull: "Selecteer een bedrijf",
      },
      personId: {
        notNull: "Selecteer een persoon",
      },
      typeId: {
        notNull: "Selecteer een relatie type",
      },
    },
  },
}
